import { createApp } from 'vue';
import { createPinia } from 'pinia';
import App from './App.vue';
import './registerServiceWorker';
import router from './router';
import store from './store';
import './index.css';

const pinia = createPinia();
const app = createApp(App);

// createApp(App).use(store).use(router).mount('#app');

app.use(store);
app.use(router);
app.use(pinia);

app.mount('#app');
